export default {
  getPaymentMethods: (state) => {
    return state.paymentMethods.filter((method) => method.value)
  },
}
